// Shared helpers + constants for the Business Health Check funnel.
const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1/health-check`;

export const FIXED_FEE = '$4,995';

export const SALUTATIONS = ['Mr.', 'Mrs.', 'Ms.', 'Mx.', 'Dr.'];

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
  'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
  'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
];

const KEY = 'kgob_intake';

export function loadIntake() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveIntake(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* storage unavailable — non-fatal */
  }
}

/** Live-format a US phone number as the user types: "(704) 555-0100".
 *  International numbers (+XX…) are left as typed. */
export function formatPhone(value) {
  const raw = String(value || '');
  const t = raw.trim();
  if (t.startsWith('+') && !t.startsWith('+1')) return raw;
  let d = raw.replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  if (d.length === 0) return '';
  if (d.length > 10) return raw;
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Capture UTM / referrer params for attribution. */export function captureMeta() {
  const meta = {};
  try {
    const p = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'].forEach((k) => {
      const v = p.get(k);
      if (v) meta[k] = v;
    });
    if (document.referrer) meta.page_referrer = document.referrer;
  } catch {
    /* ignore */
  }
  return meta;
}

export async function submitQualifier(body) {
  const res = await fetch(`${API}/qualifier`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`qualifier ${res.status}`);
  return res.json();
}

export async function submitCustomQuote(body) {
  const res = await fetch(`${API}/custom-quote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`custom-quote ${res.status}`);
  return res.json();
}
